import type { GridApi } from "~/components/grid/AgGrid";
import type { GridRequestInput } from "~/gql/graphqlBase.generated";

import clearGridFilters from "~/helpers/grid/clearGridFilters";
import gridFilterFeedback from "~/helpers/grid/gridFilterFeedback";
import { toGraphqlErrorEntries } from "~/helpers/rtkErrorClassification";

const recoverGridQueryRefusal = async (api: GridApi, request: GridRequestInput, error: unknown): Promise<boolean> => {
	if (api.isDestroyed()) return false;
	const entries = toGraphqlErrorEntries(error) ?? [];
	for (const entry of entries) {
		const message = typeof entry.extensions?.message === "string" ? entry.extensions.message : entry.message;
		const match = message?.match(/^Column '([^']+)' is not (sortable|filterable) on this grid\.$/);
		if (!match) continue;
		const [, colId, capability] = match;
		if (capability === "sortable") {
			if (!request.sortModel.some((sort) => sort.colId === colId)) continue;
			if (
				!api
					.getColumnState()
					.some(
						(column) =>
							column.colId === colId && column.sort === request.sortModel.find((sort) => sort.colId === colId)?.sort
					)
			)
				return false;
			gridFilterFeedback.notifyGridQueryRefusal(api, { colId, operation: "sort" });
			api.applyColumnState({ state: [{ colId, sort: null }] });
		} else {
			if (!request.filterModel || typeof request.filterModel !== "object" || !(colId in request.filterModel)) continue;
			const requestedModel = request.filterModel as Record<string, unknown>;
			const currentModel = api.getFilterModel();
			if (!(colId in currentModel) || JSON.stringify(currentModel[colId]) !== JSON.stringify(requestedModel[colId]))
				return false;
			gridFilterFeedback.notifyGridQueryRefusal(api, { colId, operation: "filter" });
			await clearGridFilters(api, colId);
		}
		return true;
	}
	return false;
};

export default recoverGridQueryRefusal;
